import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Form,
  Input,
  Card,
  Checkbox,
  Select,
  Button,
  DatePicker,
  message,
  InputNumber,
} from 'antd';
import {
  UserOutlined,
  MailOutlined,
  CheckCircleTwoTone,
} from '@ant-design/icons';
import keyBy from 'lodash/keyBy';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import isIsraeliIdValid from 'israeli-id-validator';
import newlocale from 'antd/es/date-picker/locale/he_IL';
import { AuthWrapper, FormWrapper } from './Auth.styled';
import { FlexDivCenter, Text } from '../../components/Typography/Typography';
import UseMedia from '../../customHooks/UseMedia';
import {
  updateUserFieldsAction,
  checkIdAction,
} from '../../data/modules/auth/auth.actions';
import 'moment/locale/he';
import { getWeboConfig } from '../../utils';
import QRCode from 'qrcode.react';

export default () => {
  const [idNumber, setIdNumber] = useState('');
  const [currentStep, setCurrentStep] = useState('id_validation');
  const [isBanMode, setIsBanMode] = useState(
    Number(window.localStorage.getItem('count_id_fails')) > 4
  );
  const { t } = useTranslation();
  const { isMobile } = UseMedia();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [token, setToken] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [schools, setSchools] = useState([]);

  const currentStepComponentMapper = {
    id_validation: renderCheckIdStep,
    signup_form: renderSignupForm,
    finished: renderFinishScreen,
  };

  useEffect(() => {
    axios.get('/schools/v1').then((res) => {
      setSchools([...new Set(res?.data?.map((s) => s?.school))]);
    });
  }, []);

  function onFinish(e) {
    e.preventDefault && e.preventDefault();
    form.validateFields().then((values) => {
      values.idNumber = idNumber;
      values.birthday = moment(values.birthday.format('YYYY/MM/DD 07:00:00'))
        .add(1, 'days')
        .format('YYYY-MM-DD 07:00:00');
      setIsLoading(true);
      dispatch(updateUserFieldsAction(values))
        .then((res) => {
          setToken(res?.data?.approvalToken);
          setCurrentStep('finished');
          // dispatch(fetchActiveUserAction()).then((_) => {
          // window.location.replace('/');
          // });
        })
        .catch((err) => {
          if (err.response.status >= 400) {
            message.error({
              content: t('bad_credentials'),
              style: {
                marginTop: '10vh',
                fontSize: 16,
              },
            });
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    });
  }

  function handleCaptcha(token) {
    setIsCaptchaValid(!!token);
  }

  function renderFinishScreen() {
    return (
      <div>
        <FlexDivCenter
          style={{
            padding: '0 20px',
            fontSize: 20,
            textAlign: 'center',
            fontWeight: 900,
            background: 'white',
            textDecoration: 'underline',
          }}
        >
          {t('screenshot_and_keep_when_taking')}
        </FlexDivCenter>
        <FlexDivCenter>
          <QRCode
            value={token}
            size={400}
            bgColor="#ffffff"
            fgColor="#000000"
            level="L"
            includeMargin
            // renderAs="svg"
          />
        </FlexDivCenter>
      </div>
    );
  }

  function renderCheckIdStep() {
    return (
      <div
        className="animate__animated animate__fadeIn"
        style={{
          maxWidth: 400,
          background: 'white',
          padding: 35,
          borderRadius: 5,
        }}
      >
        {/* <div>{t('current_step')}</div> */}
        <div>
          <Text>{t('put_your_id')}</Text>
          <Input
            onChange={(e) => setIdNumber(e.target.value)}
            value={idNumber}
            type="number"
          />
        </div>
        <FlexDivCenter>
          <ReCAPTCHA
            style={{ marginTop: 35 }}
            size="compact"
            sitekey="6LdfBLYZAAAAAMRkYqlePow956u8Up4vXIBywkNb"
            onChange={handleCaptcha}
          />
        </FlexDivCenter>
        <FlexDivCenter>
          <Button
            loading={isLoading}
            shape="round"
            disabled={!isCaptchaValid}
            onClick={(e) => checkIfIdNumberIsExist(idNumber)}
            style={{ margin: 35 }}
            type="primary"
          >
            {t('check')}
          </Button>
        </FlexDivCenter>
      </div>
    );
  }

  async function checkIfIdNumberIsExist(idNumber) {
    function _updateBan(count) {
      window.localStorage.setItem('count_id_fails', count + 1);
      if (count + 1 > 4) {
        setIsBanMode(true);
      }
    }
    const count = Number(window.localStorage.getItem('count_id_fails') || 0);
    if (
      !getWeboConfig('STORE_USE_PHONE_TO_LOGIN') &&
      !isIsraeliIdValid(idNumber)
    ) {
      _updateBan(count);
      return message.error(t('id_number_is_invalid'));
    }
    setIsLoading(true);
    const isUserValid = await dispatch(checkIdAction({ idNumber })).then(
      (res) => res?.data?.exists
    );
    setIsLoading(false);
    if (isUserValid) {
      setCurrentStep('signup_form');
    } else {
      4 - count > 0 &&
        message.error(t('id_is_not_exists', { count: 4 - count }));
      _updateBan(count);
    }
  }

  function renderSignupForm() {
    return (
      <FormWrapper
        className="animate__animated animate__fadeIn"
        isMobile={isMobile}
      >
        <Card style={{ borderRadius: 5 }} title={`${t('signup_to_sg')}`}>
          <Form
            form={form}
            name="normal_login"
            className="login-form"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <Form.Item
              label={t(
                getWeboConfig('STORE_USE_PHONE_TO_LOGIN')
                  ? 'phone_number'
                  : 'id_number'
              )}
              name="idNumber"
            >
              <Input
                disabled="true"
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder={idNumber}
              />
            </Form.Item>
            <Form.Item
              name="email"
              label={t('email_shortcut')}
              rules={[
                {
                  required: true,
                  message: t('required', { field: t('email') }),
                },
              ]}
            >
              <Input
                prefix={<MailOutlined className="site-form-item-icon" />}
                type="email"
                placeholder={t('email')}
              />
            </Form.Item>
            <Form.Item
              name="fullname"
              label={t('fullname')}
              rules={[
                {
                  required: true,
                  message: t('required', { field: t('fullname') }),
                },
              ]}
            >
              <Input placeholder={t('fullname')} />
            </Form.Item>
            {/* <Form.Item
              label={t('phone_number')}
              name="phoneNumber"
              rules={[
                {
                  required: true,
                  validator: (_, value) =>
                    value?.length === 10 && value.includes('05')
                      ? Promise.resolve()
                      : Promise.reject(new Error(t('phone_number_invalid'))),
                },
              ]}
            >
              <Input type="number" placeholder={t('phone_number')} />
            </Form.Item> */}
            <Form.Item
              label={t('school')}
              name="school"
              rules={[
                {
                  required: true,
                  message: t('required', { field: t('school') }),
                },
              ]}
            >
              <Select
                getPopupContainer={(trigger) => trigger.parentNode}
                placeholder={t('school')}
              >
                {schools.map((school) => {
                  return (
                    <Select.Option key={school} value={school}>
                      {school}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              label={t('education_year')}
              name="educationYear"
              rules={[
                {
                  required: true,
                  message: t('required', { field: t('education_year') }),
                },
              ]}
            >
              <InputNumber
                type="number"
                min={1}
                max={7}
                style={{ width: '100%' }}
                placeholder={t('education_year')}
              />
            </Form.Item>
            {getWeboConfig('SG_EXTRA_QUESTIONS') &&
              [
                { question: 'is_parent', type: 'boolean' },
                { question: 'is_military', type: 'boolean' },
                { question: 'wanna_join_to_sports', type: 'boolean' },
                { question: 'wanna_join_sg', type: 'boolean' },
              ].map((questionObject) => {
                return (
                  <Form.Item
                    label={t(questionObject.question)}
                    name={['questions', questionObject.question]}
                    rules={[
                      {
                        required: true,
                        message: t('required', {
                          field: t(questionObject.question),
                        }),
                      },
                    ]}
                  >
                    <Select
                      getPopupContainer={(trigger) => trigger.parentNode}
                      placeholder={`${t('yes')}/${t('no')}`}
                    >
                      {['yes', 'no'].map((bool) => {
                        return (
                          <Select.Option key={bool} value={bool}>
                            {t(bool)}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                );
              })}
            <Form.Item
              label={t('birthday')}
              name="birthday"
              rules={[
                {
                  required: true,
                  message: t('required', { field: t('birthday') }),
                },
              ]}
            >
              <DatePicker
                getPopupContainer={(trigger) => trigger.parentNode}
                style={{ width: '100%' }}
                locale={newlocale}
                defaultValue={moment('01/01/1997', 'DD/MM/YYYY')}
                format="DD/MM/YYYY"
              />
            </Form.Item>
            <FlexDivCenter>
              <Form.Item>
                <Button
                  loading={isLoading}
                  shape="round"
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                >
                  {t('signup')}
                </Button>
              </Form.Item>
            </FlexDivCenter>
            <FlexDivCenter
              style={{ background: 'white', borderRadius: 5, padding: 5 }}
              margin=" 0"
            >
              <Text size="large">{t('sua')}</Text>
            </FlexDivCenter>
            <FlexDivCenter>
              <a
                className="login-form-forgot"
                href={`mailto: ${getWeboConfig('STORE_SUPPORT_EMAIL')}`}
              >
                {t('having_trouble')}
              </a>
            </FlexDivCenter>
          </Form>
        </Card>
      </FormWrapper>
    );
  }

  return (
    <AuthWrapper>
      <FlexDivCenter>
        {isBanMode ? (
          <div style={{ background: 'white', padding: 35, borderRadius: 5 }}>
            {t('user_locked')}
          </div>
        ) : (
          currentStepComponentMapper[currentStep]()
        )}
      </FlexDivCenter>
    </AuthWrapper>
  );
};
